import React from "react";
import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle
} from "@fluentui/react-components";

interface StatusMessageProps {
  intent: "error" | "warning" | "success" | "info";
  title: string;
  children: React.ReactNode;
}

export const StatusMessage: React.FC<StatusMessageProps> = ({ intent, title, children }) => {
  return (
    <MessageBar intent={intent}>
      <MessageBarBody>
        <MessageBarTitle>{title}</MessageBarTitle>
        {children}
      </MessageBarBody>
    </MessageBar>
  );
};
